module.exports = __webpack_public_path__ + "img/ski-boot-ski.e1d1fdb4.svg";